import { render, staticRenderFns } from "./OrderConsigneeView.vue?vue&type=template&id=1922a348&"
import script from "./OrderConsigneeView.vue?vue&type=script&lang=js&"
export * from "./OrderConsigneeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports